var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashToc = function SvgSplashToc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.943 26.753a2.15 2.15 0 0 0 2.09 1.646c.595 0 1.076-.482 1.076-1.075V23.13h1.135a1.885 1.885 0 0 0 1.885-1.884v-1.591c2.027-.242 4.255-.639 5.902-.958 1.446-.28 2.469-1.555 2.469-3.028v-2.322a3.07 3.07 0 0 0-1.931-2.869m-1.355-.364c-1.75-.428-3.927-.915-5.826-1.205-1.634-.25-3.818-.47-5.819-.64-2.883-.248-5.319 2.05-5.319 4.942v1.935c0 2.454 1.756 4.492 4.07 4.894l1.023 4.231m4.536-4.404q.517-.039.993-.081v1.46a.63.63 0 0 1-.628.628h-.365z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M15.972 12.151a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM15.972 15.658a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM12.75 14.054a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M14.014 25.49a.418.418 0 1 1-.835 0 .418.418 0 0 1 .835 0"
  }))));
};
export default SvgSplashToc;